// Deepseek v3 API integration
// API key stored directly in this file
const DEEPSEEK_API_KEY = 'sk-8aad7087a8b54cd586893dd29ac4d7fc'; // Replace with your actual Deepseek API key

export async function fetchDeepseekResponse(prompt, fileData = null) {
    const endpoint = 'https://api.deepseek.com/v1/chat/completions';
    
    try {
        let messageContent;
        
        if (fileData) {
            if (fileData.fileType === 'text' && fileData.textContent) {
                // Handle text files - include content in prompt
                messageContent = `${prompt}\n\nFile Content (${fileData.fileName}):\n${fileData.textContent}`;
            } else if (fileData.fileType === 'image' && fileData.imageData) {
                // Handle images with vision capabilities
                messageContent = [
                    {
                        type: "text",
                        text: prompt
                    },
                    {
                        type: "image_url",
                        image_url: {
                            url: `data:${fileData.mimeType};base64,${fileData.imageData}`
                        }
                    }
                ];
            } else if (fileData.imageData && (fileData.fileType === 'pdf' || fileData.fileType === 'office' || fileData.fileType === 'video')) {
                // For non-image binary files, describe them in text (Deepseek doesn't support these as vision)
                messageContent = `${prompt}\n\nI've uploaded a ${fileData.fileType.toUpperCase()} file named "${fileData.fileName}" with MIME type "${fileData.mimeType}". Please analyze this file type and provide relevant information based on my prompt.`;
            } else {
                // Fallback for other file types
                messageContent = `${prompt}\n\nI've uploaded a file: ${fileData.fileName} (${fileData.fileType}). Please provide information about this file type and help with my request.`;
            }
        } else {
            // Handle text-only input
            messageContent = prompt;
        }

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${DEEPSEEK_API_KEY}`
            },
            body: JSON.stringify({
                model: 'deepseek-chat', // Use standard model for most cases
                messages: [
                    {
                        role: 'user',
                        content: messageContent
                    }
                ],
                max_tokens: 1024,
                temperature: 0.7,
                stream: false
            })
        });

        if (!response.ok) {
            throw new Error(`Deepseek API error: ${response.status}`);
        }

        const data = await response.json();
        
        // Extract the response text from Deepseek's response structure
        let result = data.choices?.[0]?.message?.content || 'No response from Deepseek API';
        
        // Replace any mention of Google with ChatBox AI
        result = result.replace(/\b[Gg]oogle\b/g, "ChatBox AI");
        result = result.replace(/\bChatbox AI\b/g, "ChatBox AI");
        
        return result;
        
    } catch (error) {
        console.error('Deepseek API Error:', error);
        return `Error: Unable to fetch response from Deepseek v3. ${error.message}`;
    }
}
